"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _box = require("@oneloop/box");
var _hooks = require("@oneloop/hooks");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _excluded = ["children", "variant", "itemTabSelected"],
  _excluded2 = ["id", "children", "variant", "variantBody", "variantFont", "onClick", "refTab"],
  _excluded3 = ["id", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TabsContext = /*#__PURE__*/(0, _react.createContext)();
var Tabs = exports.Tabs = function Tabs(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    _ref$itemTabSelected = _ref.itemTabSelected,
    itemTabSelected = _ref$itemTabSelected === void 0 ? 1 : _ref$itemTabSelected,
    props = _objectWithoutProperties(_ref, _excluded);
  var tabChildren = _react["default"].Children.toArray(children).filter(function (child) {
    return child.type.name === 'Tab' || child.key.toString().match('Tab');
  });
  var _useState = (0, _react.useState)(itemTabSelected && tabChildren[itemTabSelected] !== undefined && tabChildren[itemTabSelected].props.id),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var value = _react["default"].useMemo(function () {
    return {
      active: active,
      setActive: setActive
    };
  }, [active]);
  var contentChildren = _react["default"].Children.toArray(children).filter(function (child) {
    return child.type.name === 'Content' || child.key.toString().match('Content');
  });
  return /*#__PURE__*/_react["default"].createElement(TabsContext.Provider, {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({}, props, {
    tx: "tabs",
    variant: variant
  }), tabChildren), contentChildren.length > 0 && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      paddingTop: '10px'
    }
  }, contentChildren));
};
var useTabsContext = function useTabsContext() {
  var context = (0, _react.useContext)(TabsContext);
  if (!context) {
    throw new Error('Tabs compound components cannot be rendered outside the Tabs component');
  }
  return context;
};
var Tab = function Tab(_ref2) {
  var id = _ref2.id,
    children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'normal' : _ref2$variant,
    _ref2$variantBody = _ref2.variantBody,
    variantBody = _ref2$variantBody === void 0 ? 'body600' : _ref2$variantBody,
    _ref2$variantFont = _ref2.variantFont,
    variantFont = _ref2$variantFont === void 0 ? 'fontSize12' : _ref2$variantFont,
    onClick = _ref2.onClick,
    refTab = _ref2.refTab,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useTabsContext = useTabsContext(),
    active = _useTabsContext.active,
    setActive = _useTabsContext.setActive;
  var _useToggle = (0, _hooks.useToggle)(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    hover = _useToggle2[0],
    setHover = _useToggle2[1];
  var fontText = Object.values(_theme["default"].text[variantBody][variantFont]);
  var color;
  var variantValues = Object.values(_theme["default"].tab)[Object.keys(_theme["default"].tab).indexOf(variant)];
  color = variantValues.color;
  if (active === id) {
    color = variantValues[':focus'].color;
  } else if (hover) {
    color = variantValues[':hover'].color;
  }
  var onClickTab = function onClickTab() {
    setActive(id);
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    ref: refTab,
    tx: "tab",
    variant: variant,
    onClick: function onClick() {
      return onClickTab();
    },
    onMouseOver: function onMouseOver() {
      return setHover(true);
    },
    onMouseOut: function onMouseOut() {
      return setHover(false);
    }
  }, props, {
    __css: {
      position: 'relative',
      cursor: 'pointer',
      fontFamily: 'Nunito Sans',
      textTransform: variant === 'minimal' ? 'none' : 'uppercase',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      '*': {
        textDecoration: 'none',
        color: color
      },
      a: {
        display: 'block',
        width: '148px',
        height: '52px',
        lineHeight: '52px'
      },
      'a > *:first-child': {
        marginRight: '10px'
      },
      fontSize: fontText[0],
      fontWeight: fontText[1],
      lineHeight: fontText[2]
    }
  }), children, (active === id || variant !== 'normal' && hover || variant === 'minimal') && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "span",
    __css: {
      borderRadius: variant === 'normal' ? '4px 4px 0 0' : '4px',
      height: variant === 'normal' ? '4px' : undefined,
      display: 'block',
      backgroundColor: color,
      border: variant === 'normal' ? undefined : '1px solid ' + (active === id ? '#df1e02 !important' : color),
      position: 'absolute',
      right: variant === 'normal' ? '10px' : 'calc(25%)',
      left: variant === 'normal' ? '10px' : 'calc(25%)',
      bottom: 0
    }
  }));
};
var Content = function Content(_ref3) {
  var id = _ref3.id,
    children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var _useTabsContext2 = useTabsContext(),
    active = _useTabsContext2.active;
  return active === id && /*#__PURE__*/_react["default"].createElement(_box.Box, props, children);
};
Tabs.Tab = Tab;
Tabs.Content = Content;